function zoomTransform(group, transform) {
  group.call(this.zoomGen().transform, transform);
  return this;
}

export default zoomTransform;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/zoomable/zoomTransform.js